export const TRACKER_EMAIL_VERIFICATION_BANNER_OPEN = '[Email Verification Reminder] banner open';
export const TRACKER_EMAIL_VERIFICATION_BANNER_CLOSE = '[Email Verification Reminder] banner close';
export const TRACKER_EMAIL_VERIFICATION_BANNER_RESEND_CLICK = '[Email Verification Reminder] resend click';
